/**
 * @file Compares two decimal strings exactly, negative when `a` is smaller,
 * positive when larger and 0 when equal, for `Array#sort`. Consumers:
 * `analyticsGroupRows`, which sorts people and teams by booked, and
 * `analyticsInvoiceStatus`. It throws on a
 * string that is not a decimal, so callers verify each cell first.
 */
import { analyticsDecimalFraction } from '#types';

export const analyticsDecimalCompare = (a: string, b: string): number => {
  const left = analyticsDecimalFraction(a);
  const right = analyticsDecimalFraction(b);
  if (left === undefined || right === undefined)
    throw new Error(`"${a}" or "${b}" is not a decimal.`);
  const difference =
    left.numerator * right.denominator - right.numerator * left.denominator;
  return difference < 0n ? -1 : difference > 0n ? 1 : 0;
};
